import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ForuPlusLogoComponent} from './foru-plus-logo.component';

@NgModule({
  declarations: [ForuPlusLogoComponent],
  imports: [CommonModule],
  exports: [ForuPlusLogoComponent],
})
export class ForuPlusLogoModule {}
